var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// 内容站点接口封装
// 底层请求 - 基于@fe/gameSDK/fetch
// host自动选择 - 根据地区+沙箱与否选择请求的host
// 封装基于 - https://bytedance.feishu.cn/wiki/wikcnmRYckcBxat1j7qbC8wv1ib
import http, { request } from "../fetch";
var HOST_MAP = {
    "boe-sandbox": "https://act-boe.bytedance.net",
    "boe-online": "https://act-boe-cof.snssdk.com",
    "cn-sandbox": "https://act-sandbox.nvsgames.cn",
    "cn-online": "https://act.nvsgames.cn",
    "sg-sandbox": "https://act-sandbox.sgsnssdk.com",
    "sg-online": "https://act.nvsgames.com",
    "va-sandbox": "https://act-sandbox.vasnssdk.com",
    "va-online": "https://act.vasnssdk.com",
};
// 请求函数
var siteRequest = function (url, options) { return __awaiter(void 0, void 0, void 0, function () {
    var res, resData, code, data, message, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, http.request(__assign({ url: url }, options))];
            case 1:
                res = _a.sent();
                return [4 /*yield*/, res.json()];
            case 2:
                resData = _a.sent();
                code = resData.code, data = resData.data, message = resData.message;
                if (code !== 0) {
                    throw Error(message);
                }
                return [2 /*return*/, data];
            case 3:
                e_1 = _a.sent();
                throw e_1;
            case 4: return [2 /*return*/];
        }
    });
}); };
// 自动获取函数
var autoEnv = function () {
    try {
        var origin_1 = location.origin;
        if (origin_1.indexOf("bytedance.net") > -1 ||
            origin_1.indexOf("sandbox") > -1 ||
            origin_1.indexOf("localhost") > -1) {
            return "sandbox";
        }
        return "online";
    }
    catch (_) {
        return "sandbox";
    }
};
var SiteApi = /** @class */ (function () {
    function SiteApi(params) {
        var _a = params.region, region = _a === void 0 ? "cn" : _a, appId = params.appId, _b = params.language, language = _b === void 0 ? "zh-CN" : _b, _c = params.host, host = _c === void 0 ? null : _c;
        if (!appId) {
            throw Error("初始化需要配置appId");
        }
        var env = autoEnv();
        this.host = host || HOST_MAP["".concat(region, "-").concat(env)];
        this.baseRequestParams = {
            app_id: appId,
            language: language,
        };
    }
    // 获取广告无分页信息
    SiteApi.prototype.getPicture = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, advertisements;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, siteRequest(this.host + "/site/api/v2/picture/search", {
                            method: "get",
                            params: __assign(__assign({}, this.baseRequestParams), params),
                        })];
                    case 1:
                        _a = (_b.sent()).advertisements, advertisements = _a === void 0 ? [] : _a;
                        return [2 /*return*/, advertisements];
                }
            });
        });
    };
    // 获取广告带分页信息
    SiteApi.prototype.getPictureWithPage = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, advertisements, count, page_index, page_size;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, siteRequest(this.host + "/site/api/v2/picture/search", {
                            method: "get",
                            params: __assign(__assign({}, this.baseRequestParams), params),
                        })];
                    case 1:
                        _a = _c.sent(), _b = _a.advertisements, advertisements = _b === void 0 ? [] : _b, count = _a.count, page_index = _a.page_index, page_size = _a.page_size;
                        return [2 /*return*/, {
                                data: advertisements,
                                totalCount: count,
                                pageIndex: page_index,
                                pageSize: page_size,
                            }];
                }
            });
        });
    };
    // 获取新闻列表无分页信息
    SiteApi.prototype.getNews = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, top_news, _c, page_news;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, siteRequest(this.host + "/site/api/v2/news/search", {
                            method: "get",
                            params: __assign(__assign({}, this.baseRequestParams), params),
                        })];
                    case 1:
                        _a = _d.sent(), _b = _a.top_news, top_news = _b === void 0 ? [] : _b, _c = _a.page_news, page_news = _c === void 0 ? [] : _c;
                        if (params.top_flag === true) {
                            return [2 /*return*/, {
                                    top_news: top_news,
                                    page_news: page_news,
                                }];
                        }
                        return [2 /*return*/, page_news];
                }
            });
        });
    };
    // 获取新闻列表带分页信息
    SiteApi.prototype.getNewsWithPage = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, top_news, page_news, count, page_index, page_size;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, siteRequest(this.host + "/site/api/v2/news/search", {
                            method: "get",
                            params: __assign(__assign({}, this.baseRequestParams), params),
                        })];
                    case 1:
                        _a = _b.sent(), top_news = _a.top_news, page_news = _a.page_news, count = _a.count, page_index = _a.page_index, page_size = _a.page_size;
                        return [2 /*return*/, {
                                // 常规新闻列表
                                data: page_news || [],
                                // 置顶新闻列表
                                topData: top_news || [],
                                // 以下为常规新闻列表的分页信息（置顶新闻列表无分页，固定的）
                                totalCount: count,
                                pageIndex: page_index,
                                pageSize: page_size,
                            }];
                }
            });
        });
    };
    // 获取视频无分页信息
    SiteApi.prototype.getVideo = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, top_video, _c, page_videos;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, siteRequest(this.host + "/site/api/v2/video/search", {
                            method: "get",
                            params: __assign(__assign({}, this.baseRequestParams), params),
                        })];
                    case 1:
                        _a = _d.sent(), _b = _a.top_video, top_video = _b === void 0 ? [] : _b, _c = _a.page_videos, page_videos = _c === void 0 ? [] : _c;
                        if (params.top_flag === true) {
                            return [2 /*return*/, {
                                    top_video: top_video,
                                    page_videos: page_videos,
                                }];
                        }
                        return [2 /*return*/, page_videos];
                }
            });
        });
    };
    // 获取视频带分页信息
    SiteApi.prototype.getVideoWithPage = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, top_video, page_videos, count, page_index, page_size;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, siteRequest(this.host + "/site/api/v2/video/search", {
                            method: "get",
                            params: __assign(__assign({}, this.baseRequestParams), params),
                        })];
                    case 1:
                        _a = _b.sent(), top_video = _a.top_video, page_videos = _a.page_videos, count = _a.count, page_index = _a.page_index, page_size = _a.page_size;
                        return [2 /*return*/, {
                                // 常规视频列表
                                data: page_videos || [],
                                // 置顶视频列表
                                topData: top_video || [],
                                // 以下为常规视频列表的分页信息（置顶视频列表无分页，固定的）
                                totalCount: count,
                                pageIndex: page_index,
                                pageSize: page_size,
                            }];
                }
            });
        });
    };
    // 通过新闻ID获取新闻详情
    SiteApi.prototype.getNewsDetail = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var detail;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, siteRequest(this.host + "/site/api/v2/news/detail", {
                            method: "get",
                            params: __assign(__assign({}, this.baseRequestParams), params),
                        })];
                    case 1:
                        detail = _a.sent();
                        return [2 /*return*/, detail];
                }
            });
        });
    };
    // 批量获取数据带分页信息
    SiteApi.prototype.getBatchResource = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, siteRequest(this.host + "/site/api/batch/getResource", {
                            method: "post",
                            data: __assign(__assign({}, this.baseRequestParams), params),
                        })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    // 给广告、新闻、视频提供点赞、转发功能，并返回当前点赞转发数
    SiteApi.prototype.like = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var res, _a, _b, forward_count, _c, like_count;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, request({
                            url: this.host + "/site/api/common/like",
                            method: "post",
                            data: __assign(__assign({}, this.baseRequestParams), params),
                        })];
                    case 1:
                        res = _d.sent();
                        _a = res.data, _b = _a.forward_count, forward_count = _b === void 0 ? 0 : _b, _c = _a.like_count, like_count = _c === void 0 ? 0 : _c;
                        return [2 /*return*/, {
                                forward_count: forward_count,
                                like_count: like_count,
                            }];
                }
            });
        });
    };
    // 搜索广告
    SiteApi.prototype.searchPicture = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var data, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, siteRequest(this.host + "/site/api/v2/picture/keyword/search", {
                            method: "get",
                            params: __assign(__assign({}, this.baseRequestParams), params),
                        })];
                    case 1:
                        data = _a.sent();
                        res = data.advertisements || [];
                        return [2 /*return*/, res];
                }
            });
        });
    };
    // 搜索新闻
    SiteApi.prototype.searchNews = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var data, top_news, page_news;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, siteRequest(this.host + "/site/api/v2/news/keyword/search", {
                            method: "get",
                            params: __assign(__assign({}, this.baseRequestParams), params),
                        })];
                    case 1:
                        data = _a.sent();
                        top_news = data.top_news, page_news = data.page_news;
                        return [2 /*return*/, {
                                data: page_news || [],
                                topData: top_news || [],
                            }];
                }
            });
        });
    };
    // 搜索视频资源
    SiteApi.prototype.searchVideo = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var data, top_video, page_videos;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, siteRequest(this.host + "/site/api/v2/video/keyword/search", {
                            method: "get",
                            params: __assign(__assign({}, this.baseRequestParams), params),
                        })];
                    case 1:
                        data = _a.sent();
                        top_video = data.top_video, page_videos = data.page_videos;
                        return [2 /*return*/, {
                                data: page_videos || [],
                                topData: top_video || [],
                            }];
                }
            });
        });
    };
    return SiteApi;
}());
export { SiteApi };
//# sourceMappingURL=site.js.map